import React, { useState, useEffect } from "react";
import { NavLink, Route, Redirect, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { server } from "../utills/utils";
import { connect } from "react-redux";
import * as actionTypes from "../store/actions/actionTypes";

import Home from "../components/ShopAdmin/Home";
import Products from "../components/ShopAdmin/Products/Products";
import Orders from "../components/ShopAdmin/Orders/Orders";
import Notifications from "../components/ShopAdmin/ShopNotifications";
import Sales from "../components/ShopAdmin/Sales";
import Settings from "../components/ShopAdmin/Settings";
import PrimaryModal from "../components/Modals/PrimaryModal";
import Spinner from "../components/Modals/SpinnerModal";
import NotificationModal from "../components/Modals/Notification";

import styled from "styled-components";

const Nav = styled.div`
  width: 100%;
  height: 60px;
  background: black;
  position: fixed;
`;
const Container = styled.div`
  width: 85%;
  margin-left: 7.5%;
  height: auto;
  padding-top: 75px;
`;
const LeftNav = styled.div`
  width: 18%;
  height: 87vh;
  float: left;
`;
const NavItem = styled(NavLink)`
  background: white;
  display: block;
  margin-bottom: 10px;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  text-decoration: none;
  border: 1px solid #eee;
  font-weight: 500;
  color: black;
`;

const MainBody = styled.div`
  width: 80%;
  height: 87vh;
  float: right;
`;

const WarnView = styled.div`
  width: 50%;
  height: 300px;
  padding: 120px 0 0 0;
  margin-left: 25%;
`;
const InputBox = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;
const Input = styled.input`
  width: 93%;
  outline: none;
  padding: 12px 3%;
  font-size: 1.1em;
  font-weight: 400;
  background: white;
  border: 1px solid #eee;
  border-radius: 5px;
`;

const Button = styled.button`
  width: 100%;
  padding: 13px 10px;
  background: #276fb7;
  color: white;
  font-size: 1.1em;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 20px 0;
`;
const Title = styled.h2`
  font-size: 1.4em;
  color: #276fb7;
  margin: 0;
  padding: 0 0 20px 0;
  font-weight: 500;
`;
const Panel = styled(Link)`
  float: left;
  color: white;
  margin-left: 7.5%;
  font-size: 1.3em;
  font-weight: bold;
  padding: 13px 0;
  text-decoration: none;
`;
const LogoutButton = styled.div`
  float: right;
  padding: 8px 0;
  margin: 8px 7.5% 0 0;
  cursor: pointer;
`;
const LogButton = styled.button`
  font-size: 20px;
  cursor: pointer;
`;
const NotiButton = styled.button`
  color: white;
  font-size: 20px;
  background: none;
  margin-right: 10px;
  cursor: pointer;
  border: none;
`;
const NotiBadge = styled.span`
  position: absolute;
  top: 7px;
  right: 13.5%;
  padding: 4px 8px;
  border-radius: 50%;
  background-color: #276fb7;
  color: white;
  font-size: 12px;
`;
function ShopAdmin(props) {
  const [complete, setComplete] = useState(true);
  const [shop, setShop] = useState({});
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [message, setMessage] = useState("");
  const [redirect, setRedirect] = useState(null);
  const [notiModal, setModal] = useState(false);
  const [notifications, setNotis] = useState([]);
  const [newNoti, setNoti] = useState(0);

  const phoneChangeHandler = (e) => {
    setPhone(e.target.value);
  };
  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
  };

  const notificationHandler = async () => {
    if (notiModal) {
      setModal(false);
    } else {
      try {
        setNoti(0);
        await axios
          .post(server, {
            query: `
                    query{
                      shopNotifications(shopId:"${localStorage.shopId}"){
                        _id
                        userId
                        notificationType
                        shopId
                        isSeen
                        isDetailsSeen
                        user{
                          user_name
                        }
                      }
                    }
                  `,
          })
          .then((res) => {
            if (res) {
              console.log("Noti res", res);
              setNotis(res.data.data.shopNotifications);

              setModal(true);
            }
          });
      } catch (error) {
        throw error;
      }
    }
  };
  const signIngHandler = async (e) => {
    try {
      e.preventDefault();
      setSpinner(true);
      setMessage("");
      try {
        const shop = await axios.post(server, {
          query: `
                 query{
                  shopLogin(phone:"${phone}", password:"${password}"){
                      success
                      error_message
                      token
                      shopId
                  }
                 }
               `,
        });
        if (shop.data.data.shopLogin.success) {
          localStorage.setItem("shopToken", shop.data.data.shopLogin.token);
          localStorage.setItem("shopId", shop.data.data.shopLogin.shopId);
          setRedirect(<Redirect to="/merchant" />);
        } else {
          setMessage(shop.data.data.shopLogin.error_message);
        }
        setSpinner(false);
      } catch (error) {
        throw error;
      }
    } catch (error) {
      throw error;
    }
  };
  const fetchShop = async (args, req) => {
    if (localStorage.shopId) {
      const shop = await axios.post(server, {
        query: `
          query{
            shop(shopId:"${localStorage.shopId}"){
              _id
              name
              newNotification
              thanaName
              cityName
              categoryId
              categoryName
            }
          }
        `,
      });
      setNoti(shop.data.data.shop.newNotification);
      setShop(shop.data.data.shop);
      props.setMerchant(shop.data.data.shop);
    }
  };
  const logoutHandler = () => {
    try {
      localStorage.removeItem("shopToken");
      localStorage.removeItem("shopId");
      setRedirect(<Redirect to="/merchant/login" />);
    } catch (error) {
      throw error;
    }
  };

  let auth;
  if (!localStorage.shopToken) {
    auth = (
      <div>
        <PrimaryModal show="true">
          <div style={{ width: "100%" }}>
            <Title>Sign in to merchant panel</Title>
            <form onSubmit={signIngHandler}>
              <InputBox>
                <Input
                  onChange={phoneChangeHandler}
                  type="number"
                  min="0"
                  value={phone}
                  required={true}
                  placeholder="Phone number"
                />
              </InputBox>
              <InputBox>
                <Input
                  onChange={passwordChangeHandler}
                  type="password"
                  value={password}
                  required={true}
                  placeholder="Type password"
                />
              </InputBox>
              <p style={{ color: "red" }}>{message}</p>
              <Button type="submit">Sign in</Button>
            </form>
          </div>
        </PrimaryModal>
      </div>
    );
  }
  useEffect(() => {
    if (localStorage.shopToken) {
      setRedirect(<Redirect to="/merchant" />);
    }
    fetchShop();
  }, []);
  return (
    <div>
      <NotificationModal clicked={notificationHandler} show={notiModal}>
        <Notifications
          clicked={notificationHandler}
          notifications={notifications}
        />
      </NotificationModal>
      <Spinner show={spinner} />
      {redirect}
      {auth}
      <Nav>
        <Panel to="/merchant">{complete ? shop.name : "Merchant Panel"}</Panel>
        <LogoutButton>
          <NotiButton onClick={() => notificationHandler()}>
            <span>
              <FontAwesomeIcon icon={faBell} />
            </span>
            {newNoti && newNoti > 0 ? <NotiBadge>{newNoti}</NotiBadge> : null}
          </NotiButton>
          <LogButton onClick={logoutHandler}>Logout</LogButton>
        </LogoutButton>
      </Nav>
      {complete ? (
        <Container>
          <LeftNav>
            <NavItem
              to="/merchant"
              exact
              activeStyle={{ background: "#F5F5F5" }}
            >
              Home
            </NavItem>
            <NavItem
              to="/merchant/products"
              exact
              activeStyle={{ background: "#F5F5F5" }}
            >
              {console.log(
                "Hello",
                shop,
                shop.categoryId != "6129e467f8785a2974c9915a"
              )}
              {shop.categoryId != "6129e467f8785a2974c9915a"
                ? "Products"
                : "Services"}
            </NavItem>
            {shop.categoryId != "6129e467f8785a2974c9915a" ? (
              <NavItem
                to="/merchant/orders"
                activeStyle={{ background: "#F5F5F5" }}
              >
                Orders
              </NavItem>
            ) : null}

            {/* <NavItem
              to="/merchant/sales"
              exact
              activeStyle={{ background: "#F5F5F5" }}
            >
              Sales
            </NavItem>
            <NavItem
              to="/merchant/notifications"
              exact
              activeStyle={{ background: "#F5F5F5" }}
            >
              Notifications
            </NavItem> */}
            <NavItem
              to="/merchant/settings"
              exact
              activeStyle={{ background: "#F5F5F5" }}
            >
              Settings
            </NavItem>
          </LeftNav>
          <MainBody>
            <Route path="/merchant" exact component={Home} />
            <Route path="/merchant/products" exact component={Products} />
            <Route path="/merchant/orders" component={Orders} />
            <Route
              path="/merchant/notifications"
              exact
              component={Notifications}
            />
            <Route path="/merchant/settings" exact component={Settings} />
            <Route path="/merchant/sales" exact component={Sales} />
          </MainBody>
        </Container>
      ) : (
        <WarnView>
          <div
            style={{ width: "100%", height: "100%", background: "#F3F2EF" }}
          ></div>
        </WarnView>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    merchant: state.utils.merchant,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMerchant: (data) => {
      dispatch({
        type: actionTypes.SET_MERCHANT,
        data,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShopAdmin);
